import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "Categories",
    links: [
      { label: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
      { label: "Hoodies & Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
      { label: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
      { label: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
    ],
  },
  {
    title: "More Categories",
    links: [
      { label: "Pants & Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
      { label: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
      { label: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
      { label: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Pandabuy Sheet Guide", url: "/guide/pandabuy-sheet-guide", internal: true },
      { label: "All Spreadsheets", url: "https://kaspreadsheet.com" },
      { label: "Shopping Tips", url: "/guide/pandabuy-sheet-shopping-hacks", internal: true },
      { label: "Category Index", url: "https://kaspreadsheet.com" },
    ],
  },
  {
    title: "Quick Links",
    links: [
      { label: "Buy It Now", url: "https://kaspreadsheet.com" },
      { label: "Pandabuy Sheet", url: "https://kaspreadsheet.com" },
      { label: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
      { label: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
                {col.title}
              </h4>
              <hr className="border-background-300/60 mb-4 w-8" />
              <div className="flex flex-col gap-2.5">
                {col.links.map((link) =>
                  link.internal ? (
                    <Link
                      key={link.label}
                      to={link.url}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      key={link.label}
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  )
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-16 pt-10 border-t border-background-300/60 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
          <div>
            <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight leading-none">
              PANDABUY
              <br />
              SHEET
            </p>
            <hr className="border-foreground-300/40 w-12 mt-3 mb-3" />
            <p className="text-xs text-foreground-500 max-w-xs leading-relaxed">
              Smart product comparison spreadsheets for smarter buying decisions. Updated daily with fresh data across 14+ categories.
            </p>
          </div>

          <div className="flex flex-col items-start sm:items-end gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} Pandabuy Sheet. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className="ri-global-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}